// extracted by mini-css-extract-plugin
export var rateTable = "_62-0";